import React, { useRef, useState } from 'react';

import { SavedCardItemProps } from './SavedCardItem.types';
import InputPostPe from '../InputPostPe';

import visa from '../../../assets/images/visa.svg';
import master from '../../../assets/images/masterIcon.png';
import rupay from '../../../assets/images/rupayIcon.png';
import amex from '../../../assets/images/amex.svg';
import { makeStyles } from 'bharat-ui/web/Styles';
import { showPostPeUI, showTwelvePcUI } from 'utils/Utils';

const isShowTwelvePcUI = showTwelvePcUI();
const isShowPostPeUI = showPostPeUI();

const useStyle = makeStyles(() => ({
	savedCardInfoStyle: {
		//fontFamily: 'PoppinsLight',
		borderRadius: '10px',
		border: '1px solid #C6C6C6',
	},
	bankNameText: {
		fontFamily: isShowPostPeUI ? 'PoppinsRegular' : 'Regular',
		fontSize: '15px', // TODO: Convert to rem
		lineHeight: '19px',
		color: '#252525',
		letterSpacing: '0.05em',
	},
	bankNumberText: {
		fontFamily: isShowPostPeUI ? 'PoppinsRegular' : 'Regular',
		fontSize: '15px', // TODO: Convert to rem
		lineHeight: '17px',
		color: '#d0d0d0',
		letterSpacing: '0.05em',
	},
	borderCardBlue: {
		border: isShowPostPeUI
			? '1px solid #009CDE !important'
			: isShowTwelvePcUI
			? '1px solid #035857 !important'
			: '1px solid #2b80ff !important',
	},
}));

const SavedCardItem: React.FC<SavedCardItemProps> = ({
	index,
	cardInfo,
	onCardFocus,
	isCardFocused,
	onCardCvvValueChange,
}) => {
	const classes = useStyle();
	const inputRef5: any = useRef(null);
	const [cvvValue, setCvvValue] = useState('');

	const getCardTypeIcon = (type: any) => {
		switch (type.toLowerCase()) {
			case 'mastercard':
				return master;
			case 'visa':
				return visa;
			case 'amex':
				return amex;
			case 'rupay':
				return rupay;
		}
	};

	return (
		<div
			className={`${classes.savedCardInfoStyle} flex flex-center mb4 p2 mt2 ${
				isCardFocused ? classes.borderCardBlue : ''
			}`}
			key={index}
			onClick={() => inputRef5.current.focus()}>
			<img src={getCardTypeIcon(cardInfo?.network)} style={{ width: '8%' }} />
			<div className="flex flex-column w-74 text-center">
				<span className={`${classes.bankNameText}`}>{`${cardInfo?.cardType} card`}</span>
				<span className={`${classes.bankNumberText}`}>{`xxxx xxxx xxxx ${cardInfo?.lastFourDigits}`}</span>
			</div>
			<InputPostPe
				inputRef={inputRef5}
				type={'tel'}
				placeholder="CVV"
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					const value = e.target.value;
					if (
						(cardInfo?.network.toLowerCase() === 'amex' && value.length > 4) ||
						(cardInfo?.network.toLowerCase() !== 'amex' && value.length > 3)
					)
						return;
					setCvvValue(value);
					onCardCvvValueChange(value);
				}}
				value={cvvValue}
				inputContainerClassName="width-12"
				onFocus={() => {
					onCardFocus(index);
					onCardCvvValueChange(cvvValue);
				}}
				UIType={isShowTwelvePcUI ? '12pc' : isShowPostPeUI ? 'postpe' : 'merchant'}
			/>
		</div>
	);
};

export default SavedCardItem;
